import { makeRGBA } from './colors';
import { hydratedData } from 'services/hydrated-data';

const REGEXPS = {
  VARIABLE: /([^*])(-wix-([\w.-]+))/g,
  REPLACED_VARIABLE: /([^*])\/\*\*\/.+?\/\*(-wix-([\w.-]+))\*\//g,
  OPACITY: /-(\d{1,3})$/,
  COLOR: /rgb|^#/i,
  FONT_PROPERTY: /-(family|style|weight|size|decoration|line-height)$/i,
};

function isColor(value) {
  return REGEXPS.COLOR.test(value);
}

function isFont(value) {
  return REGEXPS.FONT_PROPERTY.test(value);
}

function hasOpacity(value) {
  return REGEXPS.OPACITY.test(value);
}

function getStyleValue(propName, styles) {
  const regexp = new RegExp(`${propName}:\\s*([^;]+)(?:;|$)`, 'i');

  const matched = regexp.exec(styles);

  if (!matched) {
    return null;
  }

  const value = matched[1];

  // just text-decoration - return value
  if (propName === 'text-decoration') {
    return value;
  }

  // font value - split it and return needed path
  const [style, , weight, sizeLH, ...family] = value.split(' ');
  const [size, lineHeight] = sizeLH.split('/');
  const joinedFamily = `${family.join(' ')},ruble`;

  return {
    style,
    weight,
    size,
    'line-height': lineHeight,
    family: joinedFamily,
  };
}

function getFontPropertyValue(styles, variableName) {
  const propName = REGEXPS.FONT_PROPERTY.exec(variableName)[1];

  switch (propName) {
    case 'decoration':
      return getStyleValue('text-decoration', styles);
    default:
      return getStyleValue('font', styles)[propName];
  }
}

function addOpacity(color, variableName) {
  const opacity = Number(REGEXPS.OPACITY.exec(variableName)[1]);
  return makeRGBA(color, opacity / 100);
}

function replaceVariables(settings, replaceableText, prefix, name, path) {
  path = path
    .replace(/-$/, '')
    .replace(REGEXPS.OPACITY, '')
    .replace(REGEXPS.FONT_PROPERTY, '')
    .split('-');

  let value = _.get(settings, [...path, 'value']) || _.get(settings, path);

  if (!_.isString(value)) {
    return replaceableText;
  }

  if (isColor(value) && hasOpacity(name)) {
    value = addOpacity(value, name);
  }

  if (isFont(name)) {
    value = getFontPropertyValue(value, name);
  }

  return `${prefix}/**/${value}/*${name}*/`;
}

function updateDefautValues(settings) {
  settings = _.clone(settings);

  _.forEach(['colors', 'fonts'], function(prop) {
    settings[prop] = settings[prop] || {};

    try {
      const text = document
        .getElementById(`default-${prop}`)
        .innerHTML.replace('/*', '')
        .replace('*/', '')
        .replace(/'.*?'/g, o => o.replace(/"/g, '\\"'))
        .replace(/'/g, '"');

      const obj = JSON.parse(text);

      _.forEach(obj, function(value, key) {
        settings[prop][key] = value;
      });
    } catch (error) {
      // do nothing
    }
  });

  return settings;
}

export function updateCSS(settings) {
  const preloadedStyleParams = hydratedData.getStyleParams();

  settings = preloadedStyleParams ? settings : updateDefautValues(settings);

  _(document.querySelectorAll('style'))
    .reject('id')
    .filter(
      ({ innerHTML }) =>
        REGEXPS.VARIABLE.test(innerHTML) ||
        REGEXPS.REPLACED_VARIABLE.test(innerHTML),
    )
    .forEach(function(styleTag) {
      const replaceFromCurrentSettings = _.partial(replaceVariables, settings);
      const newCss = styleTag.innerHTML
        .replace(REGEXPS.REPLACED_VARIABLE, replaceFromCurrentSettings)
        .replace(REGEXPS.VARIABLE, replaceFromCurrentSettings);
      if (styleTag.styleSheet) {
        styleTag.styleSheet.cssText = newCss;
      } else {
        styleTag.innerHTML = newCss;
      }
    });
}
